module.exports = __webpack_public_path__ + "img/banner_x_2.5ad0e0f7.png";